// extracted by mini-css-extract-plugin
export default {"heading":"Uv-z","createAccount":"Vv-z","disabled":"Wv-z","copy":"Xv-z","terms":"Yv-z"};